export const SUNX_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=io.sunx.app';
